/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type ImportSageIntacctDepartmentsInput = {
    sageIntacctDepartmentIds?: Array<number | null> | null | undefined;
    companyId?: string | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type ImportSageIntacctDepartmentsMutationVariables = {
    input: ImportSageIntacctDepartmentsInput;
};
export type ImportSageIntacctDepartmentsMutationResponse = {
    readonly importSageIntacctDepartments: {
        readonly departments: ReadonlyArray<{
            readonly node: {
                readonly id: string;
                readonly name: string | null;
                readonly sageIntacctId: string | null;
            } | null;
        } | null> | null;
    } | null;
};
export type ImportSageIntacctDepartmentsMutation = {
    readonly response: ImportSageIntacctDepartmentsMutationResponse;
    readonly variables: ImportSageIntacctDepartmentsMutationVariables;
};



/*
mutation ImportSageIntacctDepartmentsMutation(
  $input: ImportSageIntacctDepartmentsInput!
) {
  importSageIntacctDepartments(input: $input) {
    departments {
      node {
        id
        name
        sageIntacctId
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "ImportSageIntacctDepartmentsInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ImportSageIntacctDepartmentsPayload",
    "kind": "LinkedField",
    "name": "importSageIntacctDepartments",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "DepartmentTypeEdge",
        "kind": "LinkedField",
        "name": "departments",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "DepartmentType",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sageIntacctId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ImportSageIntacctDepartmentsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ImportSageIntacctDepartmentsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "ImportSageIntacctDepartmentsMutation",
    "operationKind": "mutation",
    "text": "mutation ImportSageIntacctDepartmentsMutation(\n  $input: ImportSageIntacctDepartmentsInput!\n) {\n  importSageIntacctDepartments(input: $input) {\n    departments {\n      node {\n        id\n        name\n        sageIntacctId\n      }\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '0505f0cdfb914c50ed20cb9b85e0d683';
export default node;
